var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5,9c-.1,0-.2,0-.3,0,0,0-.2,0-.2-.2L.5,5.3c-.3-.3-.3-.8,0-1.1s.8-.3,1.1,0l2.2,2.2V.8c0-.4.3-.8.8-.8s.8.3.8.8v5.7l2.2-2.2c.3-.3.8-.3,1.1,0s.3.8,0,1.1l-3.5,3.5c0,0-.2.1-.2.2,0,0-.2,0-.3,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow-down.6b81100af6fa07dc7781e02aa2e43d2a.svg";
export { ForwardRef as ReactComponent };